module.exports = __webpack_public_path__ + "img/1B1C19_5F615D_4B4E4C_3F403D-256px.7d06bb94.png";